import fullStack from "./Certificate/img-Certificate/DiplomaFullStack.jpg"
import Js from "./Certificate/img-Certificate/JavaScript.jpg"
import HTML from "./Certificate/img-Certificate/HTML.jpg"
import CSS from "./Certificate/img-Certificate/CSS.jpg"

export const Certificates = [
    {
        id : 1 ,
        description : "Certificate of appreciation from AMIT-LEARNING",
        image : fullStack,
        span : "Diploma FullStack"
    },
    {
        id : 2 ,
        description : "Certificate of appreciation from application Solo-Learning",
        image : Js,
        span : "JavaScript"
    },
    {
        id : 3 ,
        description : "Certificate of appreciation from application Solo-Learning",
        image : HTML,
        span : "HTML"
    },
    {
        id : 4 ,
        description : "Certificate of appreciation from application Solo-Learning",
        image : CSS,
        span : "CSS"
    },
]